import { createSSRApp } from "vue";
import App from "./App.vue";
import editor from './common/editor/editor.js';
import config from './common/config.js';
import moment from 'moment';

let version = "1.19.79";

var dyEditor = editor
var dyConfig = config

console.log(version);

//开发环境
const test = {
	version,
	mqtt	: 'wss://test.api.dy3d.net/dy3d',
	bucket	: 'https://dy3d.obs.cn-east-3.myhuaweicloud.com',
	api    	: 'https://test.api.dy3d.net',
	server	: 'https://vr.dy3d.net',
	oss		: 'https://vr.dy3d.net',
	avatar	: 'https://vr.dy3d.net',
	wx		: 'https://wx.duo-yuan.com/sdk/jssdk_json.php?url=',
	cdn		: 'https://vr.dy3d.net',
	origin	: 'https://%s.dy3d.net',
	appkey	: '',
};

//正式环境
const release = {
	version,
	mqtt	: 'wss://api.dy3d.net/dy3d',
	bucket	: 'https://dy3d.obs.cn-east-3.myhuaweicloud.com',
	api    	: 'https://api.dy3d.net',
	server	: 'https://vr.dy3d.net',
	oss		: 'https://vr.dy3d.net',
	avatar	: 'https://vr.dy3d.net',
	wx		: 'https://wx.duo-yuan.com/sdk/jssdk_json.php?url=',
	cdn		: 'https://vr.dy3d.net',
	origin	: 'https://%s.dy3d.net',
	appkey	: '',
};
	
let config2 = release;

config.mqtt   		= config2.mqtt;
config.api    		= config2.api;
config.bucket  		= config2.bucket;
config.server		= config2.server;
config.wx			= config2.wx;
config.oss			= config2.oss;
config.shop			= config2.shop;
config.space		= config2.space;
config.avatar		= config2.avatar;
config.cdn			= config2.cdn;
config.origin		= config2.origin;
	
export function createApp() {
	const app = createSSRApp(App);
	app.config.globalProperties.dyEditor = dyEditor
	app.config.globalProperties.dyConfig = dyConfig
	app.config.globalProperties.formatTime = time=>{ return moment(time*1000).format('YYYY-MM-DD~HH:mm') }
	  
	return { app };
}

document.addEventListener('contextmenu', e=>{
	if(e.target.tagName == 'INPUT' || e.target.getAttribute('allowSelected')) return;
	e.preventDefault();
	return false;
})

window.appConfig	= config2;
window.appVersion 	= config2.version;

window.dyEditor = dyEditor;
window.dyConfig = dyConfig;
	
//初始化热键
dyEditor.hotkey.init();
